import PropTypes from 'prop-types'

import { regexPropType } from '~/src/Lib/PropTypes'

export * from './logger'
export * from './query'
export * from './state'

export const selectedZoneType = PropTypes.oneOfType([PropTypes.number, regexPropType(/room/)])
